import { render, staticRenderFns } from "./SkusList.vue?vue&type=template&id=4c06d9a1&"
import script from "./SkusList.vue?vue&type=script&lang=ts&"
export * from "./SkusList.vue?vue&type=script&lang=ts&"
import style0 from "./SkusList.vue?vue&type=style&index=0&id=4c06d9a1&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports